module.exports = __webpack_public_path__ + "static/media/ordering-consumer.777fd99b.png";